import { render, staticRenderFns } from "./MessageDialog.vue?vue&type=template&id=12a1bc50&"
import script from "./MessageDialog.vue?vue&type=script&lang=ts&"
export * from "./MessageDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports